import { motion } from 'framer-motion'
import { Breadcrumb } from './ui/Breadcrumb'
import { Container } from './ui/Container'

interface HeroPageProps {
  title: string
  subtitle?: string
  backgroundImage?: string
  breadcrumb?: { label: string; to?: string }[]
}

export function HeroPage({
  title,
  subtitle,
  backgroundImage,
  breadcrumb,
}: HeroPageProps) {

  return (
    <section
      className="relative pt-32 pb-16 md:pt-40 md:pb-20 bg-dark overflow-hidden"
    >
      {/* Background Image */}
      {backgroundImage && (
        <>
          <div className="absolute inset-0">
            <img
              src={backgroundImage}
              alt=""
              className="w-full h-full object-cover opacity-20"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-dark/60 to-dark" />
        </>
      )}

      {/* Content */}
      <Container className="relative z-10">
        {breadcrumb && <Breadcrumb items={breadcrumb} className="mb-6" />}

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg md:text-xl text-gray-300">
              {subtitle}
            </p>
          )}
        </motion.div>
      </Container>
    </section>
  )
}
